import { PropertyWizardContext } from 'context/Context';
import { useContext } from 'react';
import Caracteristicas from './steps/Caracteristicas';
import Extras from './steps/Extras';
import Multimedia from './steps/Multimedia';
import OperacionYPropiedad from './steps/OperacionYPropiedad';
import Ubicacion from './steps/Ubicacion';

const Steps = () => {
  const { step } = useContext(PropertyWizardContext);

  switch (step) {
    case 1:
      return <OperacionYPropiedad />;

    case 2:
      return <Ubicacion />;

    case 3:
      return <Caracteristicas />;

    case 4:
      return <Multimedia />;

    case 5:
      return <Extras />;
  }
};

export default Steps;
